<template>
  <Modal
    class="confirmationModal members"
    title="Révoquer un membre"
    :isOpen="isOpen"
    @close="emits('close')"
    :buttons="[]"
  >
    <template #extra>
      <div class="round-icon">
        <i class="bi bi-exclamation-triangle-fill" />
      </div>
      <div class="title-block">
        êtes-vous sûr de vouloir révoquer
        <span
          class="primary-color"
          v-if="member.candidate_id"
          v-html="
            `${member.candidate.first_name} ${member.candidate.last_name}`
          "
        />
        <span
          class="primary-color"
          v-else
          v-html="
            member.pending_first_name && member.pending_last_name
              ? `${member.pending_first_name} ${member.pending_last_name}`
              : member.pending_email
          "
        />
        ?
      </div>
      <p class="under-text">
        Vous ne pourrez pas revenir en arrière après avoir confirmer votre
        choix.
      </p>
      <div class="btn-container">
        <Button class="primary" label="Confirmer" @click="emits('confirm')" />
        <Button
          class="secondary outline"
          label="Annuler"
          @click="emits('close')"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup>
import Modal from "@/components/global/Modal.vue";

const emits = defineEmits(["close", "confirm"]);

defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  member: {
    type: Object,
    required: true,
  },
});
</script>
